import React, { Component } from "react";
import Loading from "./Loading";
import PropTypes from "prop-types";
import InputRow from "./InputRow";

export default class WorkExperience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      companyData: [],
      Company: "",
      CompanyName: "",
      industryData: [],
      Industry: 0,
      positionData: [],
      Position: "",
      StartDate: "",
      EndDate: "",
      startDateError: "",
      EndDateError: "",
      isCurrent: false,
    };
  }

  componentDidMount() {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    fetch(
      `${process.env.REACT_APP_API_URL}/api/WorkExperience/GetOrganizations`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          companyData: res,
          Company: "",
          loading: false,
        });
        if (res.length) {
          if (this.props.workExperienceInfos.length > 0) {
            const element = this.props.workExperienceInfos[0];

            const formatDate = (dateString) => {
              const date = new Date(dateString);
              return isNaN(date.getTime())
                ? ""
                : date.toISOString().slice(0, 10);
            };

            this.setState(
              {
                Company: element.EmployerName,
                CompanyName: element.CompanyName,
                Position: element.Position,
                StartDate:
                  errorCheck.indexOf(element.StartDate) !== -1
                    ? ""
                    : formatDate(element.StartDate),
                EndDate: element.isCurrent
                  ? ""
                  : errorCheck.indexOf(element.EndDate) !== -1
                  ? ""
                  : formatDate(element.EndDate),
                isCurrent: element.isCurrent,
              },
              () => {
                this.props.collectState("WE", {
                  Company: this.state.Company,
                  CompanyName: this.state.CompanyName,
                  Industry: this.state.Industry,
                  Position: this.state.Position,
                  StartDate: this.state.StartDate,
                  EndDate: this.state.isCurrent
                    ? "2070-01-01"
                    : this.state.EndDate,
                  isCurrent: this.state.isCurrent,
                });
              }
            );
          } else {
            this.props.collectState("WE", {
              Company: this.state.Company,
              CompanyName: this.state.CompanyName,
              Industry: this.state.Industry,
              Position: this.state.Position,
              StartDate: this.state.StartDate,
              EndDate: this.state.isCurrent ? "2070-01-01" : this.state.EndDate,
              isCurrent: this.state.isCurrent,
            });
          }
        }
      })
      .catch((err) => console.log(err));
  }

  // fetchPosition() {
  //   fetch(`${process.env.REACT_APP_API_URL}/api/Employment/GetPositions`)
  //     .then((res) => res.json())
  //     .then((res) => {
  //       this.setState({
  //         positionData: res,
  //         loading: false,
  //       });
  //     })
  //     .catch((err) => console.log(err));
  // }

  handleCompanyChange(val) {
    if (val === "000000399") {
      this.setState({ Company: val, CompanyName: "" }, () => {
        this.props.collectState("WE", {
          Company: val,
          Industry: this.state.Industry,
          Position: this.state.Position,
          StartDate: this.state.StartDate,
          EndDate: this.state.isCurrent ? "2070-01-01" : this.state.EndDate,
          CompanyName: "",
          isCurrent: this.state.isCurrent,
        });
      });
    } else {
      const hName = this.state.companyData.filter(
        (ele) => parseInt(ele.Id) === parseInt(val)
      );
      const companyName = hName && hName.length > 0 ? hName[0].value : "";
      this.setState({ Company: val, CompanyName: companyName }, () => {
        this.props.collectState("WE", {
          Company: val,
          Industry: this.state.Industry,
          Position: this.state.Position,
          StartDate: this.state.StartDate,
          EndDate: this.state.isCurrent ? "2070-01-01" : this.state.EndDate,
          isCurrent: this.state.isCurrent,
          CompanyName: companyName,
        });
      });
    }
  }

  handleCompanyNameChange(val) {
    this.setState({ CompanyName: val }, () => {
      this.props.collectState("WE", {
        Company: this.state.Company,
        Industry: this.state.Industry,
        Position: this.state.Position,
        StartDate: this.state.StartDate,
        EndDate: this.state.isCurrent ? "2070-01-01" : this.state.EndDate,
        isCurrent: this.state.isCurrent,
        CompanyName: val,
      });
    });
  }

  render() {
    const validationError = this.props.error;
    const {
      loading,
      error,
      companyData,
      Company,
      CompanyName,
      isCurrent,
      industryData,
      Industry,
      positionData,
      Position,
      StartDate,
      EndDate,
      startDateError,
      EndDateError,
    } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div id="height">
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}

          <div>
            <InputRow
              name="select"
              rowName="Company Name"
              hover="Please select the company you have worked for or are currently employed with. يرجى اختيار الشركة التي عملت بها أو التي تعمل بها حالياً. "
              required="*"
              errMsg={validationError.Company ? validationError.Company : ""}
              data={companyData}
              value={Company}
              onChange={(val) => this.handleCompanyChange(val)}
            />
            {Company === "000000399" ? (
              <InputRow
                name="text"
                rowName="Company Name"
                required="*"
                errMsg={
                  validationError.CompanyName ? validationError.CompanyName : ""
                }
                value={CompanyName}
                onChange={(val) => this.handleCompanyNameChange(val)}
              />
            ) : null}

            <InputRow
              name="text"
              rowName="Position"
              required="*"
              errMsg={validationError.Position ? validationError.Position : ""}
              value={Position}
              onChange={(val) => {
                if (val.length <= 100) {
                  this.setState({ Position: val });
                  this.props.collectState("WE", {
                    Company: Company,
                    isCurrent: isCurrent,
                    CompanyName: CompanyName,
                    Industry: Industry,
                    Position: val,
                    StartDate: StartDate,
                    EndDate: this.state.isCurrent
                      ? "2070-01-01"
                      : this.state.EndDate,
                  });
                }
              }}
            />
            {/* <InputRow
              name="select"
              rowName="Position"
              value={Position}
              data={positionData}
              onChange={(e) => {
                this.setState({ Position: e });
                this.props.collectState("WE", {
                  Company: Company,
                  isCurrent: isCurrent,
                  CompanyName: CompanyName,
                  Industry: Industry,
                  Position: e,
                  StartDate: StartDate,
                  EndDate: this.state.isCurrent
                    ? "2100-01-01"
                    : this.state.EndDate,
                });
              }}
              required="*"
              errMsg={validationError.Position ? validationError.Position : ""}
            /> */}

            <InputRow
              rowName="Start Date"
              name="date"
              value={StartDate}
              required="*"
              errMsg={
                startDateError ||
                (validationError.StartDate ? validationError.StartDate : "")
              }
              onChange={(val) => {
                this.setState({ error: "" });
                const date = new Date(val);

                if (!isNaN(date.getFullYear())) {
                  if (parseInt(date.getFullYear()) <= 9999) {
                    const diffMs = Date.now() - date.getTime();
                    if (diffMs < 0) {
                      this.setState({
                        startDateError: "Please Add Valid Starting Date",
                        StartDate: "",
                      });
                    } else if (isNaN(date.getFullYear())) {
                    } else {
                      this.setState(
                        { StartDate: val, startDateError: "" },
                        () => {
                          this.props.collectState("WE", {
                            Company: Company,
                            isCurrent: isCurrent,
                            CompanyName: CompanyName,
                            Industry: Industry,
                            Position: Position,
                            StartDate: val,
                            EndDate: this.state.isCurrent
                              ? "2070-01-01"
                              : this.state.EndDate,
                          });
                        }
                      );
                    }
                  }
                } else {
                  this.setState({ StartDate: "", startDateError: "" }, () => {
                    this.props.collectState("WE", {
                      Company: Company,
                      isCurrent: isCurrent,
                      CompanyName: CompanyName,
                      Industry: Industry,
                      Position: Position,
                      StartDate: "",
                      EndDate: this.state.isCurrent
                        ? "2070-01-01"
                        : this.state.EndDate,
                    });
                  });
                }
              }}
            />

            <InputRow
              rowName="End Date"
              name="date"
              value={EndDate}
              required={isCurrent ? "" : "*"}
              disabled={isCurrent}
              errMsg={
                EndDateError ||
                (validationError.EndDate ? validationError.EndDate : "")
              }
              onChange={(val) => {
                if (isCurrent) {
                  this.setState({ EndDate: "", EndDateError: "" }, () => {
                    this.props.collectState("WE", {
                      Company: Company,
                      isCurrent: isCurrent,
                      CompanyName: CompanyName,
                      Industry: Industry,
                      Position: Position,
                      StartDate: StartDate,
                      EndDate: "2070-01-01",
                    });
                  });
                } else {
                  const edate = new Date(val);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only dates

                  if (!StartDate) {
                    this.setState({
                      EndDateError: "Please Add Starting Date First",
                      EndDate: "",
                    });
                  } else {
                    const sdate = new Date(StartDate);
                    sdate.setHours(0, 0, 0, 0);
                    if (!isNaN(edate.getTime())) {
                      edate.setHours(0, 0, 0, 0);
                      if (edate > today) {
                        this.setState({
                          EndDateError: "End Date cannot be in the future",
                          EndDate: "",
                        });
                      } else if (edate <= sdate) {
                        this.setState({
                          EndDateError: "End Date must be after Start Date",
                          EndDate: "",
                        });
                      } else {
                        this.setState(
                          { EndDate: val, EndDateError: "" },
                          () => {
                            this.props.collectState("WE", {
                              Company: Company,
                              isCurrent: isCurrent,
                              CompanyName: CompanyName,
                              Industry: Industry,
                              Position: Position,
                              StartDate: StartDate,
                              EndDate: val,
                            });
                          }
                        );
                      }
                    } else {
                      this.setState({
                        EndDateError: "Please enter a valid date",
                        EndDate: "",
                      });
                    }
                  }
                }
              }}
            />
            <label>
              <input
                type="checkbox"
                checked={isCurrent}
                onChange={(e) => {
                  if (e.target.checked) {
                    this.setState(
                      { EndDate: "", isCurrent: true, EndDateError: "" },
                      () => {
                        this.props.collectState("WE", {
                          Company: this.state.Company,
                          isCurrent: this.state.isCurrent,
                          CompanyName: this.state.CompanyName,
                          Industry: this.state.Industry,
                          Position: this.state.Position,
                          StartDate: this.state.StartDate,
                          EndDate: "2070-01-01",
                        });
                      }
                    );
                  } else {
                    this.setState({ isCurrent: false, EndDate: "" }, () => {
                      this.props.collectState("WE", {
                        Company: this.state.Company,
                        CompanyName: this.state.CompanyName,
                        isCurrent: this.state.isCurrent,
                        Industry: this.state.Industry,
                        Position: this.state.Position,
                        StartDate: this.state.StartDate,
                        EndDate: this.state.isCurrent
                          ? "2070-01-01"
                          : this.state.EndDate,
                        isCurrent: false,
                      });
                    });
                  }
                }}
              />
              Currently Employed
            </label>
          </div>
        </div>

        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}

WorkExperience.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  workExperienceInfos: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
};
